var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"level"},[_c('img',{attrs:{"src":_vm.LevelData.imgUrl,"alt":"","图片":""}}),_vm._v(" "),_c('div',{staticClass:"numbers"},[_c('span',{staticClass:"big"},[_vm._v(_vm._s(_vm.LevelData.superscript)+"/")]),_c('span',{staticClass:"small"},[_vm._v(_vm._s(_vm.LevelData.subscript))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35d4576e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mycom/level.vue
// module id = null
// module chunks = 